import React from "react";
import headerImage from "../../../public/static/images/jpg/Belanja_di_Toko_Website-Banner.jpg";
import headerMiniImage from "../../../public/static/images/jpg/Belanja_di_Toko_Mini_Web-Banner.jpg";
import BannerComponent from "../UserInterface/BannerComponent";
import BreadcrumbComponent from "../UserInterface/BreadcrumbComponent";
import UseWindowSize from "../../components/UseWindowSize";
import { useState, useEffect } from "react";

const ShopOfflineProduct = ({ subtitle, title, path }) => {
  const OfflineProductBreadcrumb = [
    { page: "Beranda", href: "/", to: "/" },
    {
      page: "Belanja di Toko",
      href: "/belanja-di-toko",
      to: "/belanja-di-toko"
    },
    { page: title, href: "", to: "" }
  ];
  const { width } = UseWindowSize();
  const [winSize, setWinSize] = useState(null);

  useEffect(() => {
    setWinSize(width);
  });

  return (
    <div className="offline-products-wrapper">
      <div className="offline-products-header-container">
        <BreadcrumbComponent items={OfflineProductBreadcrumb} />
        <BannerComponent
          img={winSize > 700 ? headerImage : headerMiniImage}
          visible
          mobileHeight="100%"
        ></BannerComponent>
      </div>
      <style jsx>{`
        .offline-products-wrapper {
          display: flex;
          flex-direction: column;
        }

        .offline-products-terms-wrapper {
          display: flex;
          justify-content: center;
        }

        .offline-products-container {
          max-width: 940px;
          width: 100%;
          font-weight: bold;
        }
        .offline-products-header {
          height: 120px;
          padding: 8px 0;
          background-color: var(--color-red);
        }
        .offline-products-header h1 {
          font-weight: bold;
          margin: 0px 16px 8px 16px;
          font-size: 16px;
          color: var(--color-white);
        }
        .offline-products-header p {
          font-size: 12px;
          width: auto;
          margin: 16px;
          color: var(--color-white);
        }
      `}</style>
    </div>
  );
};

export default ShopOfflineProduct;
